import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addProfile from "./components/addProfile";
export default {
  name: "profileManagement",
  mixins: [loadMoreList],
  components: {
    addProfile: addProfile
  },
  data: function data() {
    return {
      pagingReqFn: "subConfigList",
      delIds: [],
      loginData: '',
      previewVisible: false,
      jsonData: '',
      paramsData: {
        file_desc: ''
      }
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delSubConfig',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    },
    preViewJson: function preViewJson(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(row.download_url).then(function (response) {
                  return response.json();
                }).then(function (data) {
                  // 成功获取数据后，可以在这里处理数据
                  _this2.jsonData = JSON.stringify(data, null, 2);
                  _this2.previewVisible = true;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    downLoad: function downLoad(row) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var fileName, match;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fileName = row.file_desc;
                match = row.download_url.match(/\/([^\/]+)\.json$/);

                if (match && match[1]) {
                  fileName = match[1];
                }

                _context2.next = 5;
                return fetch(row.download_url).then(function (response) {
                  return response.json();
                }).then(function (data) {
                  // 成功获取数据后，可以在这里处理数据
                  var jsonData = JSON.stringify(data, null, 2); // 创建下载链接

                  var blob = new Blob([jsonData], {
                    type: 'application/json'
                  });
                  var url = URL.createObjectURL(blob); // 创建下载链接元素

                  var a = document.createElement('a');
                  a.href = url;
                  a.download = fileName + '.json';
                  document.body.appendChild(a);
                  a.click(); // 清理

                  setTimeout(function () {
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                  }, 100);
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};